/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
console.log("Hello World! (from sd-viblock-sd-product-sizes block)");
/* eslint-enable no-console */
(function () {
	const block = document.getElementById('sd-viblocks-product-sizes');
	const container = block.querySelector('.sizes-grid-container');
	const prevBtn = block.querySelector('.sizes-nav-prev');
	const nextBtn = block.querySelector('.sizes-nav-next');
	const items = block.querySelectorAll('.size-item');

	let currentIndex = 0;

	function updateNavigation() {
		if (window.innerWidth >= 768) {
			prevBtn.style.display = 'none';
			nextBtn.style.display = 'none';
			return;
		}

		prevBtn.style.display = 'flex';
		nextBtn.style.display = 'flex';
		prevBtn.disabled = currentIndex === 0;
		nextBtn.disabled = currentIndex === items.length - 1;
	}

	function scrollToItem(index) {
		if (window.innerWidth < 768) {
			const item = items[index];
			if (item) {
				container.scrollTo({
					left: item.offsetLeft - 20,
					behavior: 'smooth'
				});
				currentIndex = index;
				updateNavigation();
			}
		}
	}

	prevBtn.addEventListener('click', () => {
		scrollToItem(Math.max(0, currentIndex - 1));
	});

	nextBtn.addEventListener('click', () => {
		scrollToItem(Math.min(items.length - 1, currentIndex + 1));
	});

	window.addEventListener('resize', updateNavigation);
	updateNavigation();
})();
